export default __webpack_public_path__ + "static/media/Icon menu Campaign _ Inactive.65555c19.svg";